import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { ListItem, type ListItemProperties } from "./list-item";
import type { IcIcon } from "@jetblue/kit-icons/types";
import { cn } from "../../utilities/tailwind";

export type ListProperties<C extends ElementType> = {
  Icon?: IcIcon | undefined;
  children?: ReactNode | undefined;
  className?: string | undefined;
  items?: ListItemProperties[] | undefined;
  type?: "list-decimal" | "list-disc" | "list-none" | undefined;
} & ComponentPropsWithoutRef<C>;
export const List = <C extends ElementType>({
  Icon,
  children,
  className = "",
  items,
  type = "list-none",
  ...properties
}: ListProperties<C>) => {
  const ListComponent = type === "list-decimal" ? "ol" : "ul";
  const useHTMLDecorations = type === "list-decimal" || type === "list-disc";
  const twClassName = cn({ "pl-10": useHTMLDecorations }, type, className);

  return (
    <ListComponent className={twClassName} {...properties}>
      {items?.map((item, index) => {
        const previousItemHasNestedContent = Boolean(items[index - 1]?.items);

        return (
          <ListItem
            Icon={Icon}
            hasMarginTop={!previousItemHasNestedContent && index > 0}
            key={item.id}
            {...item}
          />
        );
      })}

      {children}
    </ListComponent>
  );
};
export { ListItem, type ListItemProperties } from "./list-item";
List.displayName = "List";
